export default __webpack_public_path__ + "static/gw2-banner-combat-da34167533f35e237decf2236d9c3365.png";